import React from "react";
import { useSelector } from "react-redux";

import { StoreType } from "../../../utils/types";

const useWorkerRequestsData = () => {
	const allSwapRequests = useSelector(
		(state: StoreType) => state.workerRequests.allShiftSwapRequests
	);
	const allSwapRequestsStatus = useSelector(
		(state: StoreType) => state.workerRequests.shiftSwapRequests.status
	);

	const updateRequestsStatus = useSelector(
		(state: StoreType) => state.workerRequests.updateSwapRequests.status
	);
	const allRegularRequests = useSelector(
		(state: StoreType) => state.workerRequests.allRegularRequests
	);
	const getAllRegularRequestsStatus = useSelector(
		(state: StoreType) => state.workerRequests.getAllRegularRequests.status
	);
	const shiftFormData = useSelector(
		(state: StoreType) => state.workerRequests.shiftFormData
	);
	const fullTimeRequestStatuses = useSelector(
		(state: StoreType) => state.workerRequests.fullTimeRequestStatuses
	);
	const flexRequestStatuses = useSelector(
		(state: StoreType) => state.workerRequests.flexRequestStatuses
	);
	const requestActionStatus = useSelector(
		(state: StoreType) => state.workerRequests.requestShiftAction.status
	);
	const requestActionErrorMessage = useSelector(
		(state: StoreType) => state.workerRequests.requestShiftAction.errorMessage
	);

	const allJobs = useSelector(
		(state: StoreType) => state.supervisor.masterData.allJobRoles
	);

	const workerRequestMetaData = useSelector(
		(state: StoreType) => state.workerRequests.workerRequestMetaData
	);

	const attendanceManagement = useSelector(
		(state: StoreType) => state.user.userData.attendanceManagement
	);

	const callOffLineEnabledLocations = useSelector(
		(state: StoreType) => state.user.userData.callOffLineEnabledLocations
	);

	const renotifyWorkersStatus = useSelector(
		(state: StoreType) => state.supervisor.renotifyWorkers.status
	);

	const userRoles = useSelector((state: any) => state.user.userData.userRoles);
	const userRolesWithPermission = useSelector(
		(state: any) => state.user.userData.userRolesWithPermissions
	);

	const isWorkerSubTypeEnabled = useSelector(
		(state: any) => state.user.userData.workerSubTypeEnabled
	);

	const leaveCalendarCounts = useSelector(
		(state: StoreType) => state.workerRequests.leaveCalendarCounts.data
	);
	const leaveCalendarCountsStatus = useSelector(
		(state: StoreType) => state.workerRequests.leaveCalendarCounts.status
	);
	const leaveCalendarDetails = useSelector(
		(state: StoreType) => state.workerRequests.leaveCalendarDetails.data
	);
	const leaveCalendarDetailsStatus = useSelector(
		(state: StoreType) => state.workerRequests.leaveCalendarDetails.status
	);
	const leaveCalendarTimeline = useSelector(
		(state: StoreType) => state.workerRequests.leaveCalendarTimeline.data
	);
	const leaveCalendarTimelineStatus = useSelector(
		(state: StoreType) => state.workerRequests.leaveCalendarTimeline.status
	);

	const getFiltersForUser = useSelector(
		(state: StoreType) => state.workerRequests.getFiltersForUser.data
	);
	const getFiltersForUserStatus = useSelector(
		(state: StoreType) => state.workerRequests.getFiltersForUser.status
	);

	const timeOffRequestFilters = useSelector(
		(state: StoreType) => state.workerRequests.timeOffRequestFilters.data
	);
	const timeOffRequestFiltersStatus = useSelector(
		(state: StoreType) => state.workerRequests.timeOffRequestFilters.status
	);
	const flexShiftRequestFilters = useSelector(
		(state: StoreType) => state.workerRequests.flexShiftRequestFilters.data
	);
	const flexShiftRequestFiltersStatus = useSelector(
		(state: StoreType) => state.workerRequests.flexShiftRequestFilters.status
	);

	return {
		allSwapRequests,
		allSwapRequestsStatus,
		updateRequestsStatus,
		allRegularRequests,
		getAllRegularRequestsStatus,
		shiftFormData,
		fullTimeRequestStatuses,
		flexRequestStatuses,
		requestActionStatus,
		requestActionErrorMessage,
		allJobs,
		workerRequestMetaData,
		attendanceManagement,
		callOffLineEnabledLocations,
		renotifyWorkersStatus,
		userRoles,
		userRolesWithPermission,
		isWorkerSubTypeEnabled,
		leaveCalendarCounts,
		leaveCalendarCountsStatus,
		leaveCalendarDetails,
		leaveCalendarDetailsStatus,
		leaveCalendarTimeline,
		leaveCalendarTimelineStatus,
		getFiltersForUser,
		getFiltersForUserStatus,
		timeOffRequestFilters,
		timeOffRequestFiltersStatus,
		flexShiftRequestFilters,
		flexShiftRequestFiltersStatus,
	};
};

export default useWorkerRequestsData;
